var React = require('react');

function PlayIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"18","cy":"18","r":"17.5","stroke":"#00AF41","key":0}),React.createElement("path",{"d":"M15.1985 23.8866L23.6103 18.7008C23.9853 18.4682 24.1103 17.9654 23.875 17.5751C23.8088 17.4625 23.7132 17.3725 23.6103 17.3049L15.1985 12.1117C14.8235 11.8866 14.3382 12.0066 14.1103 12.3894C14.0368 12.517 14 12.667 14 12.8096V23.1886C14 23.6389 14.3529 23.9991 14.7868 23.9991C14.9338 24.0066 15.0735 23.9616 15.1985 23.8866Z","fill":"#2C2C2C","key":1})]);
}

PlayIcon.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = PlayIcon;

PlayIcon.default = PlayIcon;
